import { FC, useCallback, useEffect, useState } from 'react';
import { useI18n } from 'src/hooks/use-i18n-translation';
import { usePostMesssage } from 'src/hooks/use-postMessage';
import { useSessionRecorder } from 'src/hooks/use-session-recorder';
import { getSocialLinks } from 'src/services/cmsApi';
import { SocialType } from 'src/types/res-dto/configs';
import './styles.scss';

type Props = {
  settings: {
    needLogin: false;
    priority: number;
    styles: Styles;
  };
  placement: 'header' | 'footer' | 'sidebar';
};
const SocialNetworks: FC<Props> = ({ settings, placement }) => {
  const { styles } = settings;
  const sessionRecorder = useSessionRecorder();
  const { locale } = useI18n();

  const [socials, setSocials] = useState<SocialType[]>([]);

  const getSocialsData = useCallback(async (): Promise<void> => {
    const res = await getSocialLinks(locale);

    if (res.success) {
      const _linksData =
        res.result?.map((item: any) => {
          return {
            name: item?.content?.name,
            link: item?.content?.link,
            imageSrc: item?.content?.icon?.path,
            withImage: !!item?.content?.icon?.path,
            styles: {},
          };
        }) || [];

      setSocials(_linksData);
    }
  }, [locale]);

  const onLinkClick = (name: string): void => {
    sessionRecorder?.trackEvent('Social link click', {
      placement,
      name,
    });
  };

  const setTemplate = (icon: SocialType, i: number): JSX.Element => {
    if (icon.link) {
      return (
        <a
          onClick={() => onLinkClick(icon.name)}
          key={`${icon}_${i}`}
          className="social_icon_wrapper"
          href={icon.link}
          target="_blank"
        >
          <img src={icon.imageSrc} alt={icon.name ?? ''} style={icon.styles} />
        </a>
      );
    }

    return (
      <span onClick={() => onLinkClick(icon.name)} key={`${icon}_${i}`} className="social_icon_wrapper">
        <img src={icon.imageSrc} alt={icon.name ?? ''} style={icon.styles} />
      </span>
    );
  };

  useEffect(() => {
    getSocialsData();
  }, [getSocialsData]);

  usePostMesssage((v: any) => setSocials(v), 'socials');

  return (
    <div style={styles} className={`social_networks_container ${placement}`}>
      {socials?.map((icon: SocialType, i: number) => setTemplate(icon, i))}
    </div>
  );
};
export default SocialNetworks;
